import { Injectable, OnDestroy, OnInit } from '@angular/core'
import { TrackingService } from 'app/_jaettu-angular/tracking'

@Injectable({
  providedIn: 'root',
})
export class TrackingServiceLemonaidImpl implements TrackingService, OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy() {}

  logAction(actionId: string) {}

  logNavigation(url: string, description: string, asiakasAvain: string | null, kirjanpitajaUid: string) {}
}
